import React from "react";

export const Sign = ({ text, isDoubleSided }) => (
  <React.Fragment>
    <div className='top-indent'>
      <span className='title'>{text}</span>
    </div>
    <div className={`full-sign-line top-indent ${isDoubleSided && 'double-sided-sign'}`} />
  </React.Fragment>
)
